var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteS(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_624",
    "data-name": "Group 624",
    transform: "translate(-33.5 -60.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_613",
    "data-name": "Rectangle 613",
    width: 10,
    height: 12,
    transform: "translate(36 63)",
    fill: "none",
    stroke: "#ff324e",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_122",
    "data-name": "Line 122",
    x2: 14,
    transform: "translate(34 63)",
    fill: "none",
    stroke: "#ff324e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    d: "M40,63.333V61h4.667v2.333",
    transform: "translate(-1.333)",
    fill: "none",
    stroke: "#ff324e",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_123",
    "data-name": "Line 123",
    y2: 3.889,
    transform: "translate(39.056 67.222)",
    fill: "none",
    stroke: "#ff324e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_124",
    "data-name": "Line 124",
    y2: 3.889,
    transform: "translate(42.944 67.222)",
    fill: "none",
    stroke: "#ff324e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteS);
export default __webpack_public_path__ + "static/media/delete-s.0d2bccd205b93a4dcf8969eb3523259e.svg";
export { ForwardRef as ReactComponent };